import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "../ui/accordion";
import { useLang } from "../../i18n/LanguageContext";

export const FAQ = () => {
  const { t } = useLang();
  const items = [
    { q: t.faq.q1, a: t.faq.a1 },
    { q: t.faq.q2, a: t.faq.a2 },
    { q: t.faq.q3, a: t.faq.a3 },
    { q: t.faq.q4, a: t.faq.a4 },
    { q: t.faq.q5, a: t.faq.a5 },
  ];

  return (
    <section
      id="faq"
      data-testid="faq-section"
      className="py-20 lg:py-28 bg-stone-100/60 border-y border-stone-200"
    >
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center max-w-2xl mx-auto">
          <span className="font-mono-label text-stone-600">{t.faq.eyebrow}</span>
          <h2 className="font-display mt-3 text-3xl sm:text-4xl lg:text-5xl tracking-tight text-stone-900 leading-tight">
            {t.faq.title}
          </h2>
        </div>

        <Accordion type="single" collapsible className="mt-12">
          {items.map((it, i) => (
            <AccordionItem
              key={i}
              value={`item-${i}`}
              data-testid={`faq-item-${i + 1}`}
              className="bg-white border border-stone-200 rounded-xl px-6 mb-3 last:mb-0"
            >
              <AccordionTrigger className="text-left font-display text-lg text-stone-900 hover:no-underline py-5">
                {it.q}
              </AccordionTrigger>
              <AccordionContent className="text-stone-600 leading-relaxed pb-5">
                {it.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
};
